export default {
  common: {
    clearAll: 'Cancella tutto',
    required: 'Richiesto',
    restart: 'Riavviare'
  },
  createUser: {
    acceptTermsAndConditions: 'Accettare i termini e le condizioni',
    alreadyHaveAccount: 'Hai già un account? %{pre}Scarica%{post}',
    checkEmail: 'Nel frattempo, scaricare Metrica Play sul proprio computer',
    clubCompany: 'Organizzazione/Club',
    createdSuccessfully:
      "Registrazione riuscita! Controllare l'e-mail di registrazione per ottenere un link di verifica. (Controllare la cartella spam)",
    email: 'Email',
    invalidEmail: 'Email non valida',
    job: 'Lavoro/Ruolo',
    lastName: 'Cognome',
    name: 'Nome',
    noCustomOption: 'Opzione non disponibile',
    noMatches: 'Nessuna corrispondenza, scrivere la propria opzione',
    password: 'Password',
    passwordsDontMatch: 'Password non corrispondenti',
    passwordInvalid: 'La password non soddisfa i requisiti',
    passwordRequirements: {
      minLength: 'Almeno %{count} caratteri',
      uppercase: 'Una lettera maiuscola',
      lowercase: 'Una lettera minuscola',
      number: 'Un numero (0-9)',
      maxLength: 'Al massimo %{count} caratteri'
    },
    phone: 'Telefono',
    phoneCode: 'Paese',
    proceed: 'Procedere',
    repeatPassword: 'Ripetere la password',
    searchPhoneCode: 'Cerca...',
    seeTermsAndConditions: 'Vedi termini e condizioni',
    signAgreement:
      'Registrarti su un account di Metrica Sports significa che accetti la %{pre1}Politica sulla Privacy%{post1} e i %{pre2}Termini di Servizio%{post2}',
    signUpHere: 'Crea il tuo account per iniziare.',
    sport: 'Sport',
    submitting: 'Avvio...',
    title: 'Inizia con %{product}',
    userKeyField: 'Hai un Codice Promozionale o una Chiave di Accesso? Compilate questo campo'
  },
  error: {
    downloadPlay: "Se avete già un account, scaricate l'ultima versione di Play e accedete.",
    emailTaken: 'Questa e-mail è già stata presa',
    fieldTooLong: 'Alcuni campi sono troppo lunghi. Accorciali e riprova',
    oops: 'Ops!',
    restart: 'Sembra che tu stia cercando di entrare in qualcosa che stiamo ancora sviluppando...',
    tryAgain:
      "Si prega di riprovare, se l'errore continua, contattare il team di supporto di Metrica Sports.",
    userKey:
      'Credenziale non valida. Controllare la chiave di accesso e riprovare o eliminare il campo per completare la registrazione.'
  },
  invitation: {
    acceptButton: 'Accetto il Cambio del Mio Account',
    accepting: 'Accettando...',
    cancelButton: 'Rifiutare',
    description1:
      "Quando vieni aggiunto al nuovo account di Metrica Sports, la proprietà del tuo attuale account di Metrica Sports (e le informazioni in esso contenute) verrà trasferita e assegnata al nuovo proprietario dell'account di Metrica Sports. Tutte le informazioni e i dati attualmente contenuti nel tuo account di Metrica Sports, così come qualsiasi informazione o dato salvato dopo aver accettato il cambio di account, saranno visibili e disponibili per il nuovo proprietario dell'account di Metrica Sports e per qualsiasi amministratore(i) di tale account, per usarli e condividerli con altri a discrezione del proprietario dell'account.",
    description2:
      'Facendo clic su "Accetto la Modifica del Mio Account" accetti e autorizzi quanto segue:',
    list1:
      'Le informazioni del tuo account attuale verranno trasferite al nuovo account di Metrica Sports.',
    list2:
      "Tutte le informazioni dell'account trasferite al tuo nuovo account di Metrica Sports dal tuo account attuale possono essere gestite dal nuovo proprietario dell'account e/o dagli amministratori.",
    list3:
      'Nel nuovo account di Metrica Sports, il tuo ruolo sarà "Membro". Non avrai più privilegi di proprietario o di amministratore del tuo account attuale.',
    list4:
      "Erediterai le impostazioni esistenti del tuo nuovo account di Metrica Sports, che possono essere più o meno restrittive a seconda del tuo ruolo nell'account, e le tue impostazioni potranno essere gestite dal nuovo proprietario o amministratore(i) dell'account di Metrica Sports.",
    list5:
      "Le tue impostazioni attuali potrebbero essere modificate se entrano in conflitto con le impostazioni dell'account nuovo al quale ti unisci.",
    list6:
      'È possibile che il tuo nuovo account non fornisca accesso a tutte le funzioni che hai nel tuo account attuale.',
    list7:
      "Non è possibile annullare la trasferenza del tuo account una volta che l'hai iniziata, e tutte le tue informazioni sull'account rimarranno in un unico account.",
    list8:
      'Cliccando su "Accetto il Cambio del Mio Account", diventerai un membro gestito dell\'account di %{pre1}%{email}%{post1} e accetti i %{pre2}Termini di Servizio%{post2} e la %{pre3}Dichiarazione sulla Privacy%{post3} di Metrica Sports.',
    subtitle:
      "Accettando questo nuovo invito all'account di Metrica Sports, verrai aggiunto a un altro account di Metrica Sports.",
    title: 'Invito'
  },
  jobs: {
    academyDirector: "Direttore dell'Academy",
    assistantCoach: 'Allenatore in seconda',
    dataAnalyst: 'Data Analyst',
    doctor: 'Medico',
    formerPlayer: 'Ex Giocatore',
    goalkeeperCoach: 'Preparatore dei portieri',
    headCoach: 'Allenatore',
    journalist: 'Giornalista',
    other: 'Altro',
    performance: 'Fitness e Prestazioni',
    player: 'Giocatore',
    scout: 'Osservatore',
    sportsDirector: 'Direttore sportivo',
    student: 'Studente',
    videoAnalyst: 'Video Analyst'
  },
  sports: {
    americanFootball: 'Football Americano',
    baseball: 'Baseball',
    basketball: 'Pallacanestro',
    fieldHockey: 'Hockey su prato',
    football: 'Calcio',
    futsal: 'Calcio a 5',
    gaelicFootball: 'Calcio gaelico',
    handball: 'Pallamano',
    iceHockey: 'Hockey su ghiaccio',
    lacrosse: 'Lacrosse',
    netball: 'Netball',
    other: 'Altro',
    padel: 'Padel',
    rugby: 'Rugby',
    tennis: 'Tennis',
    volleyball: 'Pallavolo'
  }
}
